import {useEffect, useRef, useState} from 'react';
import Style from '../../Style';
import SidebarLink from "../sidebar/SidebarLink";
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { SearchField } from '../common/SearchField';
import {handleError} from "../../utilities/AlertableErrorHandler";
import {useSnackbar} from "notistack";
import { useHistory } from "react-router-dom";

import {Sidebar, Segment, Divider, Table, Button, Loader, Dimmer, Message, Grid, Container} from "semantic-ui-react";

import { SearchSubscriptionPagePresenter } from './SearchSubscriptionPagePresenter';
import MainHeader from '../mainHeader/MainHeader';

function SubscriptionPage(props) {
    const [searchValue, setSearchValue] = useState("");
    const [loader, setLoader] = useState(false);
    const [tenantList, setTenantList] = useState(undefined);

    const presenter = useRef(new SearchSubscriptionPagePresenter);
    const {enqueueSnackbar} = useSnackbar();

    const history = useHistory();

    useEffect(() => {
        if (props.location.state?.email !== undefined) {
            setSearchValue(props.location.state?.email);
        }
    },[])

    useEffect(() => {
        if (searchValue.length > 1) {
            setLoader(true);
            getTenantList();
        }
    }, [searchValue] )

    function getTenantList() {
        presenter.current.getTenantList({
            searchValue: searchValue.trim(),
            onSuccess: (response) => {
                setLoader(false);
                setTenantList(response);
            },
            onError: (error) => {
                setLoader(false);
                handleError(error, enqueueSnackbar);
            }
        })
    }

    return (
        <div style={Style.mainDiv}>
            <SidebarLink/>
            <Sidebar.Pushable>
                <MainHeader/>
                <div style={Style.dashboardDiv} className="font">
                    <Grid style={{paddingLeft:"27%"}}>
                        <Grid.Row>
                        <Segment.Group style={{width:"63%"}}>
                            <Segment>
                                <h2 style={Style.centraliseTitle}>Search Organizations with Email</h2>
                            </Segment>
                            <Segment>
                                <Grid>
                                    <Grid.Row style={{paddingBottom:'0rem'}}>
                                        <div style={{paddingLeft:'15px', width:'100%'}}>
                                            <SearchField getSearchValue={setSearchValue} clearValue={setTenantList} searchValue={searchValue} email={true}/>
                                        </div>
                                    </Grid.Row>
                                        {loader ? 
                                            <Grid.Row style={{height:'90px'}}>
                                                <div>
                                                    <Loader active={loader}>Getting List</Loader>
                                                </div>
                                            </Grid.Row> : 
                                            <Grid.Row>
                                                {tenantList !== undefined && 
                                                    <div style={{width:'96%', marginLeft:'2%'}}>
                                                        {tenantList !== null ? 
                                                            <Container>
                                                                <Divider/>
                                                                    <Table compact>
                                                                        <Table.Header>
                                                                            <Table.HeaderCell>Organization(s)</Table.HeaderCell>
                                                                            <Table.HeaderCell textAlign='right' style={{paddingRight:'45px'}}>Action</Table.HeaderCell>
                                                                        </Table.Header>
                                                                        <Table.Body>
                                                                            {tenantList.map((data) => (
                                                                                <Table.Row key={data.TenantID}>
                                                                                    <Table.Cell>{data.TenantName}</Table.Cell>
                                                                                    <Table.Cell textAlign='right'>
                                                                                        <Button onClick={() => history.push("/subscription/view_details", {data: data.TenantID, tenantName: data.TenantName, email: searchValue })}>View</Button>
                                                                                    </Table.Cell>
                                                                                </Table.Row>
                                                                            ))}
                                                                        </Table.Body>
                                                                </Table>
                                                            </Container> : 
                                                            <Container>
                                                                <Divider/>
                                                                <Message warning>
                                                                    <Message.Header>No Organization</Message.Header>
                                                                </Message>
                                                            </Container>
                                                        }
                                                    </div>
                                                }
                                            </Grid.Row>
                                        }
                                    </Grid>
                            </Segment>
                        </Segment.Group>
                        </Grid.Row>
                    </Grid>
                </div>
            </Sidebar.Pushable>
        </div>
    )
}

function mapStateToProps(state = {}, ownProps) {
    return{};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPage);